export default __webpack_public_path__ + "static/Headless-ae10154da3ed47406d8d08f72a896f11.png";